import { Outlet } from "react-router-dom";
import ModuleNavbar from "../ModuleNavbar";
import { Sidebar } from "../Sidebar";
import DetailsNavbar from "../DetailsNavbar/DetailsNavbar";

export default function DashboardLayout() {
  return (
    <>
      <DetailsNavbar/>
      <div className="app-shell-with-header">
        <Sidebar />

        <>
          <Outlet />
        </>
      </div>
    </>
  );
}